const bodyScrollLock = require('body-scroll-lock/lib/bodyScrollLock.es6');

const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const options = {};

const toggleLock = function (lock, target) {

    let targetElement = $(target)[0];

    if (lock) {
        disableBodyScroll(targetElement);
    } else {
        enableBodyScroll(targetElement, options);
    }
};

export default toggleLock;